import axios from "axios";
import _ from 'lodash'

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.interceptors.request.use(async config=>{
    const app = JSON.parse(localStorage.getItem('app')) 
    if(_.get(app, 'token')) {
        config.headers.Authorization = `Bearer ${app.token}`
    } 
    return config;
})
axios.interceptors.response.use(async response => {   
    return response;
},(error)=> {
    const status = 200;//error.response;
    switch(status){
        case 400:         
            break;
        case 401:           
            break;
        case 404:           
            break;
        case 500:           
            break;
        default:
            break;
    }
    return Promise.reject(error);
})

const responseBody = (response) => {return response.data};

const requests = {
    get: (url, param) =>  axios.get(url, {params: param}).then(responseBody),      
    post: (url, body, param) => axios.post(url, body, {params: param}).then(responseBody),
    put: (url, body, param) => axios.put(url, body, {params:param}).then(responseBody),
    delete: (url, param) => axios.delete(url, {params: param}).then(responseBody) 
};

const Setup = {

    getBuildingById:(id)=>requests.get(`/v1/bed-management/building/${id}`, {}), 
    getIntermediateById:(type, id)=>requests.get(`v1/bed-management/inter-mediate-level/${type}/${id}`, {}),
    getBedById:(id)=>requests.get(`/v1/bed-management/bed/${id}`, {}),
    getStaff:(searchValue)=>requests.get(`/v1/bed-management/staff/search/${searchValue}`, {}),
    getInheritedStaff:(parentType, parentId)=>requests.get(`v1/bed-management/staff/inherit/${parentType}/${parentId}`, {}),

   
    saveBuilding:(data)=>requests.post('/v1/bed-management/building', data, {}),
    saveIntermediate:(data, type)=> requests.post(`v1/bed-management/inter-mediate-level/${type}`, data, {}),
    saveBed:(data)=>requests.post('/v1/bed-management/bed', data, {}),

    updateBuilding:(data)=>requests.put('/v1/bed-management/building', data, {}),
    updateIntermediate:(data, type)=> requests.put(`v1/bed-management/inter-mediate-level/${type}`, data, {}),
    updateBed:(data)=>requests.put('/v1/bed-management/bed', data, {}),

    deleteBuildingById:(id)=>requests.delete(`/v1/bed-management/building/${id}`, {}),
    deleteIntermediateById:(type, key)=>requests.delete(`v1/bed-management/inter-mediate-level/${type}/${key}`, {}),
    deleteBedById:(id)=>requests.delete(`/v1/bed-management/bed/${id}`, {}),

    duplicateBuilding:(data)=>requests.post('/v1/bed-management/building/duplicate', data, {}),
    duplicateIntermediate:(data, type)=> requests.post(`v1/bed-management/inter-mediate-level/duplicate`, data, {}),
    duplicateBed:(data)=>requests.post('/v1/bed-management/bed/duplicate', data, {}),
}
const Setting = {
    getAddBedStatus:()=> requests.get('/v1/bed-management/settings/bed/status/all', {}),
    saveBedStatus:(data)=>requests.post('/v1/bed-management/settings/bed/status', data, {}),
    updateBedStatus:(data)=>requests.put('/v1/bed-management/settings/bed/status', data, {}),

    getAddBedTypes:()=> requests.get('/v1/bed-management/settings/bed/type/all', {}),
    saveBedType:(data)=>requests.post('/v1/bed-management/settings/bed/type', data, {}),
    updateBedType:(data)=>requests.put('/v1/bed-management/settings/bed/type', data, {}),

    getAddBedTags:()=> requests.get('/v1/bed-management/settings/bed/tag/all', {}),
    saveBedTag:(data)=>requests.post('/v1/bed-management/settings/bed/tag', data, {}),
    updateBedTag:(data)=>requests.put('/v1/bed-management/settings/bed/tag', data, {}),

    getDayCodes:()=> requests.get('/v1/bed-management/refdata/attendance/daycodes/all', {}),
    getAttendanceStatus:()=> requests.get('/v1/bed-management/attendance/all', {}),
    saveAttendanceStatus:(data)=>requests.post('/v1/bed-management/attendance', data, {}),
    updateAttendanceStatus:(data)=>requests.put('/v1/bed-management/attendance', data, {}),
}

const Census = {
   
    getClients:(searchValue)=>requests.get(`/v1/bed-management/client/search/${searchValue}`,{}),
    getBedAssignmentData: (assignmentId)=> requests.get(`/v1/bed-management/client-assignment/${assignmentId}`, {}),

    saveBedAssignOrReserve:(data)=>requests.post('/v1/bed-management/client-assignment', data, {}),
    updateBedAssignOrReserve:(data)=>requests.put('/v1/bed-management/client-assignment', data, {}),
    checkBedAvailability:(data)=>requests.post('/v1/bed-management/client-assignment/check-availability', data, {}),
    moveClient:(data)=>requests.post('/v1/bed-management/client-assignment/move', data, {}),
    getClientDetails: (assignmentId)=> requests.get(`/v1/bed-management/history/client/assignment/${assignmentId}`, {}),
    getBedDetailsByIdAndDate:(id, data)=>requests.post(`/v1/bed-management/bed/${id}`, data, {}),
    getBedOccupantHistory:(id)=>requests.get(`/v1/bed-management/history/bed/${id}`, {}),
    getClientBedHistory:(id)=>requests.get(`/v1/bed-management/history/client/${id}`, {})
} 

const Attendance = {
    createClientAttendance:(attendance)=>requests.post('/v1/bed-management/attendance/client', attendance, {}),
    updateClientAttendance:(attendance)=>requests.put('/v1/bed-management/attendance/client', attendance, {})
}

const Hierarchy = {
    getLocationTree: ()=> requests.get('/v1/bed-management/structure/location/all',  {}),  
    getLocationTreeById:(id)=>requests.get(`/v1/bed-management/structure/location/${id}`, {}), 
    getMultipleLocationTreeWithFilter:(filter)=>requests.post(`v1/bed-management/structure`, filter, {}),
    getLocationTreeWithFilter:(locationId, filter)=>requests.post(`/v1/bed-management/structure/location/${locationId}`, filter, {}),

}

const Location = {
    getLocations:()=> requests.get('/v1/bed-management/refdata/location/all', {}),
    getStates:()=>requests.get('/v1/bed-management/refdata/state/all', {}),
    getPrograms:()=>requests.get('/v1/bed-management/refdata/program/all', {}),
    getPrimaryLocationId: ()=>requests.get('v1/bed-management/refdata/location/staff/primary', {})

}

const Authorization = {
    getToken:(username)=>requests.get(`/v1/security/token/${username}`, {}),
}

const Services = {
    Setup,
    Setting,
    Census,
    Attendance,
    Authorization,
    Hierarchy,
    Location
}

export default Services;


